/**
 *  API URL Config
 */

// 로컬 서버
// export const IAM_PATH = 'https://10.10.4.20:9090';
// export const PAY_MODULE_PATH = 'http://10.10.4.20:8080/api';     
// export const STORE_MODULE_PATH = 'http://10.10.4.20:9090/api/v1/store';

// 배포 서버
export const IAM_PATH = 'https://iam.innocode.co';
// export const PAY_MODULE_PATH = 'http://14.32.21.178:38080/api';  
export const PAY_MODULE_PATH = 'https://zenta-pay-api.innocode.co/api';
export const STORAGE_MODULE_BASE_URL = 'https://storage.innocode.co';
export const STORE_MODULE_PATH = 'https://zenta-store-api.innocode.co/api/v1/store';

// OAuth IAM API
export const OAUTH_AUTHORIZE = IAM_PATH + '/oauth/authorize';
export const OAUTH = IAM_PATH + '/oauth';
export const OAUTH_TOKEN = IAM_PATH + '/oauth/token';

// 간편로그인연동
export const ESEY_LOGIN_OAUTH2 = IAM_PATH + '/oauth2/authorization';

//이메일인증
export const EMAIL_VERIFICATION = IAM_PATH + '/rest/verification';

//멀티펙터(MFA)
export const IAM_MFA_OTP = IAM_PATH + '/api/v1/mfa/otp';
export const IAM_SERVER_MULTIFACTORPOLICY = IAM_PATH + "/rest/multifactorpolicy";


// Identity & IdentityDetail Controller API 주소
export const IAM_SERVER_UNIFIEDPROFILE = IAM_PATH + "/rest/unifiedProfile";
export const IAM_SERVER_UNIFIEDID = IAM_PATH + "/rest/unifiedId";


// Service 관련 Controller API 주소
export const IAM_SERVER_TENANT = IAM_PATH + "/rest/tenants";
export const IAM_SERVER_PROFILES = IAM_PATH + "/rest/profiles";
export const IAM_SERVER_TENANT_USER = IAM_PATH + "/rest/tenantUser";
export const IAM_SERVER_TENANT_USER_REGIST = IAM_PATH + "/rest/tenantUser/invite";
export const IAM_SERVER_SERVICE = IAM_PATH + "/rest/service";
export const IAM_SERVER_AUTH_TOKEN_POLICY = IAM_PATH + "/rest/authTokenPolicy";
export const IAM_SERVER_SERVICE_USER = IAM_PATH + "/rest/serviceUser";
export const IAM_SERVER_SERVICE_PAGE = IAM_PATH + "/rest/accessPage";
export const IAM_SERVER_SERVICE_AUTH = IAM_PATH + "/rest/accessAuthority";
export const IAM_SERVER_SERVICE_PAGEAUTH = IAM_PATH + "/rest/accessAuthorityDetail";
export const IAM_SERVER_SERVICE_GROUP = IAM_PATH + "/rest/serviceGroup";
export const IAM_SERVER_SSO_ADMIN = IAM_PATH + "/oauth/sso/admin";



//로그 현황 페이지 controller API 주소
export const IAM_SERVER_AUDIT_ADMIN = IAM_PATH + '/rest/audits';

//로그 현황 페이지 controller API 주소
export const IAM_SERVER_DASHBOARD = IAM_PATH + '/rest/dashboard';


//zenapay
export const ZENPAY_BILLING = PAY_MODULE_PATH + '/billingkey';
export const ZENPAY_PAYMENT = PAY_MODULE_PATH + '/payment';
export const ZENPAY_PAY_PASSWORD = PAY_MODULE_PATH + '/pay-password';
export const ZENPAY_SUBSCRIPTION = PAY_MODULE_PATH + '/subscription';


//store
export const STORE_ORDER = STORE_MODULE_PATH + '/order';










/**
 * Iam Config
 */
export const CLIENT_ID = 'iam_zentry';
export const CLIENT_SECRET = '1908daf584ed8872f9aa792fcb9a26eaf8fb7aa181a89a4b436a4d0940cadcdc';
export const RESPONSE_TYPE = 'code';
export const REDIRECT_URI = 'https://inpost.innocode.co/api/test-client/callback';
export const SCOPE = 'openid email phone address roles profile offline_access sub_profile current_profile';
export const STATE = 'xyz';
export const NONCE = '12345';


export const API_ODCLOUD_PATH = 'https://api.odcloud.kr';
export const API_businessman_PATH = '/api/nts-businessman/v1/status';
export const API_businessman_serviceKey = 'TTK4j5r79XavAk4HeCTN6JPaOF%2F08I%2BcxrZz6%2BFC37aiDqW2VZnmGXVkp4K0veFfL6GBtMlFPYdQels%2BhkXrOQ%3D%3D';
export const API_businessman = API_ODCLOUD_PATH + API_businessman_PATH + '?serviceKey=' + API_businessman_serviceKey;
